import React from 'react';
import styled from 'styled-components';

import { colors } from '../../healtheraComponents';
import { ReactComponent as Icon } from '../../resources/information-icon.svg';

const Tip = ({ children }) => {
  return (
    <StyledTip>
      <TipIcon>
        <Icon />
      </TipIcon>
      <TipContent>{children}</TipContent>
    </StyledTip>
  );
};

const TipContent = styled.p`
  padding: 5px;
  margin: 0;
  position: absolute;
  top: -2px;
  left: 15px;
  font-size: 12px;
  opacity: 0.7;
  color: ${colors.GRAY_DARK};
  width: 100%;
`;

const TipIcon = styled.p`
  margin: 0;
  width: 15px;

  svg {
    width: 100%;
    height: 100%;
    fill: ${colors.HEALTHERA_GREEN};
  }`;

const StyledTip = styled.div`
  display: flex;
  position: relative;
`;

export default Tip;
